import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/pre-sanction-setting",
        component: List,
        name: "admin-pre-sanction-setting-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/pre-sanction-setting/:id/edit",
        component: Edit,
        name: "admin-pre-sanction-setting-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/pre-sanction-setting/create",
        component: Create,
        name: "admin-pre-sanction-setting-create",
        meta: {
            requiresAuth: true,
        },
    },
];
